.water-mark-setting {
  padding-bottom: 34px;
}
